import { Link } from "react-router-dom";
import { LayoutDashboard, ShoppingCart, Server, Network, LogOut, ShieldCheck } from "lucide-react";
import { ThemeToggle } from "@/components/ThemeToggle";

export function Sidebar({ tab, setTab, user, logout }) {
  const NAV = [["dashboard", "Home", LayoutDashboard], ["resi", "Resi", ShoppingCart], ["isp", "ISP", Server], ["subnets", "Subnets", Network],
    ...(user?.role === "admin" ? [["admin", "Admin", ShieldCheck]] : [])];
  return (
    <aside className="fixed inset-y-0 left-0 z-40 w-[84px] flex flex-col items-center py-5 text-white"
      style={{ background: "linear-gradient(180deg,#0C221F 0%,#08302A 55%,#052220 100%)" }}>
      <Link to="/" className="w-11 h-11 rounded-xl bg-white/10 grid place-items-center mb-8 hover:bg-white/20 transition-colors overflow-hidden" data-testid="sidebar-logo">
        <img src="/logo.png" alt="FR Proxies" className="w-full h-full object-contain" />
      </Link>
      <nav className="flex-1 flex flex-col gap-2 w-full px-3">
        {NAV.map(([k, label, Icon]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`nav-tab-${k}`}
            className={`group relative flex flex-col items-center gap-1 py-3 rounded-2xl transition-colors ${tab === k ? "bg-white/12 text-[#2DD4BF]" : "text-white/55 hover:text-white hover:bg-white/5"}`}>
            {tab === k && <span className="absolute left-0 top-1/2 -translate-y-1/2 h-6 w-1 rounded-r bg-[#2DD4BF]" />}
            <Icon className="w-5 h-5" aria-hidden="true" />
            <span className="text-[10px] font-medium tracking-wide">{label}</span>
          </button>
        ))}
      </nav>
      <div className="flex flex-col items-center gap-3 w-full px-3">
        <ThemeToggle iconSize={20} className="w-10 h-10 text-white/60 hover:text-[#2DD4BF] hover:bg-white/5" />
        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#2DD4BF] to-[#0B5F57] grid place-items-center font-semibold text-sm">{(user?.name || user?.email || "U")[0].toUpperCase()}</div>
        <button onClick={logout} data-testid="logout-button" className="text-white/50 hover:text-[#FF6B8A] transition-colors py-2"><LogOut className="w-5 h-5" /></button>
      </div>
    </aside>
  );
}
